import React from 'react';
import { Button } from 'reactstrap';

import { PRIMARY_COLOR } from 'theme';

const StopButton = ({
  show,
  stopCommandLoading,
  organizationColor,
  onClick,
}) => {
  const backgroundColor = organizationColor ? organizationColor : PRIMARY_COLOR;

  if (!show) return null;

  return (
    <div style={{ padding: 16 }}>
      <Button
        id="stop-charging"
        className="action-button"
        style={{
          color: 'white',
          backgroundColor,
          borderColor: backgroundColor,
          opacity: stopCommandLoading ? 0.4 : 1,
        }}
        onClick={onClick}
        disabled={stopCommandLoading}
      >
        {stopCommandLoading ? 'Stopping Session' : 'Stop Charging'}
      </Button>
    </div>
  );
};

export default StopButton;
